// @flow
import { get } from 'lodash';
import React from 'react';
import {
  BulletList,
  Bullet,
  Text,
  Card,
  Section
} from 'seek-style-guide/react';
import CompanySuggestion from '../CompanySuggestion/CompanySuggestion';

type Props = {
  companySuggestion?: SearchViewModelCompanySuggestion
};

const GENERIC = (
  <Card data-automation="searchZeroResults">
    <Section>
      <Text subheading>
        Sorry, we couldn&rsquo;t find anything. Maybe try taking the following
        steps&hellip;
      </Text>
      <BulletList>
        <Bullet>
          Change or remove filters such as classification to broaden your
          search.
        </Bullet>
        <Bullet>Check for spelling errors.</Bullet>
        <Bullet>Remove keywords such as AND, NOT and OR.</Bullet>
      </BulletList>
    </Section>
  </Card>
);

const company = (companySuggestion: SearchViewModelCompanySuggestion) => (
  <Card data-automation="company-search-zero-results">
    <Section>
      <Text subheading>
        Sorry, there are no jobs at {companySuggestion.search.keywords}.
      </Text>
      <CompanySuggestion companySuggestion={companySuggestion} />
    </Section>
  </Card>
);

export default ({ companySuggestion }: Props) =>
  companySuggestion && get(companySuggestion, ['search', 'keywords'])
    ? company(companySuggestion)
    : GENERIC;
